// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(false);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".has-border-bottom-grey-light[data-v-4e4b7c44]{border-bottom:1px solid #dbdbdb}.color-tertiary[data-v-4e4b7c44]{color:#2cd5c4}.color-primary[data-v-4e4b7c44]{color:#ef4a81}.color-grey-darker[data-v-4e4b7c44]{color:#363636}.color-grey[data-v-4e4b7c44]{color:#7a7a7a}.help.is-danger[data-v-4e4b7c44]{position:static}.origin-option[data-v-4e4b7c44]{display:flex;flex-direction:row;justify-content:space-between}", ""]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___;
